import { render, staticRenderFns } from "./DialogDetalhes.vue?vue&type=template&id=46b9a5c1&scoped=true&"
import script from "./DialogDetalhes.vue?vue&type=script&lang=js&"
export * from "./DialogDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./DialogDetalhes.vue?vue&type=style&index=0&id=46b9a5c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9a5c1",
  null
  
)

export default component.exports